import type {
  PartnerThirdPartyBillingAccountSet,
  PartnerThirdPartyBillingAccountSetCreate,
  PartnerThirdPartyBillingAccountSetUpdate,
} from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const thirdPartyBillingAccountSets = {
  get: {
    queryKey: 'partner-management-service/third-party-billing-account-sets/id',
    fn: async (thirdPartyBillingAccountSetId: string) => {
      const { data } = await GatewayAxiosClient.get<PartnerThirdPartyBillingAccountSet>(
        `/partner-management-proxy/api/v1/partners/thirdPartyBillingAccountSets/${thirdPartyBillingAccountSetId}`,
      );

      return data;
    },
  },
  create: async (payload: PartnerThirdPartyBillingAccountSetCreate) => {
    const { data } = await GatewayAxiosClient.post<PartnerThirdPartyBillingAccountSet>(
      '/partner-management-proxy/api/v1/partners/thirdPartyBillingAccountSets',
      payload,
    );

    return {
      invalidateQueryKeys: [['partner-management-service/third-party-billing-account-sets']],
      data,
    };
  },
  update: async ({
    thirdPartyBillingAccountSetId,
    payload,
  }: {
    thirdPartyBillingAccountSetId: string;
    payload: PartnerThirdPartyBillingAccountSetUpdate;
  }) => {
    const { data } = await GatewayAxiosClient.put<PartnerThirdPartyBillingAccountSet>(
      `/partner-management-proxy/api/v1/partners/thirdPartyBillingAccountSets/${thirdPartyBillingAccountSetId}`,
      payload,
    );

    return {
      invalidateQueryKeys: [
        ['partner-management-service/third-party-billing-account-sets'],
        ['partner-management-service/third-party-billing-account-sets/id', thirdPartyBillingAccountSetId],
      ],
      data,
    };
  },
};
